"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MOTIVOS_PERDA = exports.TIPOS_MOVIMENTO_ESTOQUE = exports.LOCALIZACOES_FIXAS = void 0;
exports.normalizarUnidade = normalizarUnidade;
/** Ids fixos das localizações semeadas pela migration 20261001_p01_estoque_ledger. */
exports.LOCALIZACOES_FIXAS = {
    RECEBIMENTO: { id: '00000000-0000-4000-8000-000000001301', nome: 'Recebimento' },
    ALMOXARIFADO: { id: '00000000-0000-4000-8000-000000001302', nome: 'Almoxarifado' },
    PRODUCAO: { id: '00000000-0000-4000-8000-000000001303', nome: 'Produção' },
    QUALIDADE: { id: '00000000-0000-4000-8000-000000001304', nome: 'Qualidade' },
    EXPEDICAO: { id: '00000000-0000-4000-8000-000000001305', nome: 'Expedição' },
};
exports.TIPOS_MOVIMENTO_ESTOQUE = [
    'ENTRADA_COMPRA',
    'SALDO_ABERTURA',
    'AJUSTE_INVENTARIO',
    'SAIDA_TINTA',
    'DEVOLUCAO_TINTA',
    'PERDA',
    'CONSUMIVEL_SETOR',
    'TRANSFERENCIA',
    'ESTORNO',
];
const SINONIMOS_UNIDADE = {
    lt: 'l',
    litro: 'l',
    litros: 'l',
    pc: 'pç',
    pç: 'pç',
    peça: 'pç',
    peca: 'pç',
    kgs: 'kg',
    quilo: 'kg',
    quilos: 'kg',
};
/** Normaliza a unidade de medida (trim + minúsculas + sinônimos). Vazio quando ausente. */
function normalizarUnidade(unidade) {
    const base = (unidade ?? '').trim().toLowerCase();
    return SINONIMOS_UNIDADE[base] ?? base;
}
// ---------------------------------------------------------------------------------------------------------------------
// Fase 13, Plano 08 (EST-09, EST-14, EST-16, D-06, D-07, D-09, D-11, D-12): transferência, perda, consumível e estorno
// ---------------------------------------------------------------------------------------------------------------------
exports.MOTIVOS_PERDA = ['VENCIDA', 'CONTAMINADA', 'DERRAMAMENTO', 'BORRA', 'OUTRO'];
//# sourceMappingURL=estoque.js.map